<template>
  <v-container grid-list-md>
    <pi-progress v-if="progress" main></pi-progress>
    <pi-navigation :navigation="navigation"></pi-navigation>

    <v-layout row wrap>
      <v-flex v-for="group in groups" :key="group.id" xl3 lg4 sm6>
        <pi-groupcard :group="group">
          <v-menu
            bottom
            left
            v-if="Auth.check(Permissions['GROUP_DELETE']) || Auth.check(Permissions['GROUP_EDIT'])"
          >
            <v-btn icon slot="activator">
              <v-icon>more_horiz</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-if="Auth.check(Permissions['GROUP_EDIT'])"
                :to="`/group/${group.id}/edit`"
              >
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                v-if="Auth.check(Permissions['GROUP_DELETE'])"
                @click="showDeleteDialog(group)"
              >
                <v-list-tile-title>Usuń</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </pi-groupcard>
      </v-flex>
    </v-layout>

    <v-btn
      color="accent"
      dark
      bottom
      right
      fab
      fixed
      to="/group/create"
      v-if="Auth.check(Permissions['GROUP_ADD'])"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <pi-dialog
      :dialog="deleteDialog.on"
      :progress="deleteDialog.progress"
      headline="Usuwanie grupy"
      operation="Usuń"
      @closed="showDeleteDialog(null)"
      @action="deleteData()"
    >Czy chcesz usunąć grupę {{ deleteDialog.obj.name }}?</pi-dialog>

    <pi-snackbar :color="snackbar.color" :snackbar.sync="snackbar.on" :message="snackbar.message"></pi-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    progress: false,
    snackbar: { on: false, color: "error", message: "" },
    groups: [],
    navigation: [],
    deleteDialog: { on: false, obj: {}, progress: false }
  }),
  methods: {
    async getData() {
      this.progress = true;
      const response = await this.Api.send("get", "/groups");
      this.progress = false;
      if (response.status) {
        this.groups = response.groups;
        return;
      }
      this.showError(response.message);
    },
    async createNavigation() {
      this.navigation = [{ id: 0, text: "Grupy", href: "/group/all" }];
    },
    async showDeleteDialog(obj) {
      this.deleteDialog.obj = obj ? obj : {};
      this.deleteDialog.on = !!obj;
    },
    async deleteData() {
      this.deleteDialog.progress = true;
      const response = await this.Api.send(
        "delete",
        `/groups/${this.deleteGroup.id}`
      );
      this.deleteDialog.progress = false;
      if (response.status) {
        this.showDeleteDialog(null);
        this.showSuccess("Grupa usunięta");
        this.getData();
        return;
      }
      this.showDeleteDialog(null);
      this.showError(response.message);
    },
    async showError(message) {
      this.snackbar.color = "error";
      this.showMessage(message);
    },
    async showSuccess(message) {
      this.snackbar.color = "success";
      this.showMessage(message);
    },
    async showMessage(message) {
      this.snackbar.message = message;
      this.snackbar.on = true;
    }
  },
  async mounted() {
    await this.getData();
    this.createNavigation();
  }
};
</script>
